import { useCallback } from 'react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export const usePdfMaker = () => {
    return useCallback(async (tableElement: HTMLElement, filename: string) => {
        if (!tableElement) {
            return;
        }
        const canvas = await html2canvas(tableElement, {
            scale: 2,
            useCORS: true
        });
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF();
        const marginX = 10;
        const marginY = 15;
        const pageWidth = pdf.internal.pageSize.getWidth();
        // const pageHeight = pdf.internal.pageSize.getHeight();
        const usableWidth = pageWidth - 2 * marginX;
        const usableHeight = (canvas.height * usableWidth) / canvas.width;
        pdf.addImage(imgData, 'PNG', marginX, marginY, usableWidth, usableHeight);
        pdf.save(filename);
    }, []);
}
